import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Typography.module.css';
export const Heading = forwardRef(({ as: Component = 'h2', size, weight = 'bold', align = 'left', className = '', children, ...props }, ref) => {
    const headingSize = size || Component.slice(1);
    const classes = [
        styles.heading,
        styles[`heading${headingSize}`],
        styles[`weight${weight.charAt(0).toUpperCase() + weight.slice(1)}`],
        styles[`align${align.charAt(0).toUpperCase() + align.slice(1)}`],
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { ref: ref, className: classes, ...props, children: children }));
});
Heading.displayName = 'Heading';
